import React from 'react';
import { MTextBlockSimple } from '../MTextBlockSimple/index';
import { MButton } from '../MButton/index';
import * as Styled from './MOverlayCta.styles';
import type { MOverlayCtaProps } from './MOverlayCta.types';

const COMPONENT_NAME = 'm-web-ui-kit-MOverlayCta';
const TEST_ID = 'web-ui-kit-MOverlayCta';

export const MOverlayCta: React.FC<MOverlayCtaProps> = ({
  mTextBlockSimple,
  mButton,
  // Default theme is inverse unless explicitly overridden.
  className = 'inverse',
}) => {
  const hasTextBlockContent = Boolean(
    mTextBlockSimple &&
      (mTextBlockSimple.eyebrowText?.trim() || mTextBlockSimple.headerText?.trim() || mTextBlockSimple.bodyText?.trim())
  );

  return (
    <Styled.Wrapper data-component-name={COMPONENT_NAME} data-testid={TEST_ID} className={className}>
      {hasTextBlockContent && (
        <Styled.TextBlockWrapper>
          <MTextBlockSimple {...mTextBlockSimple} />
        </Styled.TextBlockWrapper>
      )}
      {mButton && (
        <Styled.ButtonWrapper>
          <MButton {...mButton} />
        </Styled.ButtonWrapper>
      )}
    </Styled.Wrapper>
  );
};

export * from './MOverlayCta.types';
